<span class="app-tooltip">
  <mat-icon
    class="icon"
    [pTooltip]="htmlText"
    tooltipPosition="{{ tooltipPosition }}"
    hideDelay="{{ hideDelay }}"
    tooltipStyleClass="{{ class }}"
    svgIcon="help"
    [escape]="false"
  ></mat-icon>
</span>
